import { SpinnerSize } from './spinner.types';

export const SpinnerSizeMap: Record<SpinnerSize, number> = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
};
